export var EStateActionTypes;

(function (EStateActionTypes) {
  EStateActionTypes["SetState"] = "state/setState";
  EStateActionTypes["ResetStateToPhoneAuth"] = "state/resetToPhoneAuth";
  EStateActionTypes["ResetStateToUsernameAuth"] = "state/resetToUsernameAuth";
  EStateActionTypes["ChangeStateToPhoneAuth"] = "state/changeToPhoneAuth";
  EStateActionTypes["ChangeStateToUsernameAuth"] = "state/changeToUsernameAuth";
})(EStateActionTypes || (EStateActionTypes = {}));